<app-modal [header]="'preferred_sample.title' | translate">
  <div modal-body class="d-flex flex-column h-100">
    <span class="mb-3">{{ 'preferred_sample.dialog.text' | translate }}</span>
    <div class="d-flex flex-grow-1 gap-2 overflow-hidden">
      <div style="width: 200px">
        <app-dropdown class="w-100" [label]="'technicalInfoProperty.2' | translate" [items]="colors()" (selectedItemChange)="selectColor($event)"/>
      </div>
      <div class="flex-grow-1 d-flex flex-column overflow-hidden">
        <app-article-result-list [showArticleImage]="true"
                                 [tableData]="filteredTableData()"
                                 [tableColumns]="tableColumns"
                                 [selectedArticle]="selectedArticle()"
                                 (selectedArticleChange)="selectedArticle.set($event)"
                                 (articleAction)="openShopLink($event.article.articleNo)"
                                 *noItemWrapper="filteredTableData(); text: (tableData().length === 0 ? 'preferred_sample.no_items' : 'preferred_sample.no_items_for_filters') | translate"
        />
      </div>
    </div>
  </div>
  <button modal-footer class="btn btn-secondary btn-cancel" type="button" (click)="cancel()">{{ 'global.label.close' | translate }}</button>
</app-modal>
